/**
 * รับช่วง "บริษัทของแท็บนี้" ตอนเปิดแท็บใหม่จาก portal
 *
 * หลักการ: sessionStorage แยกกันคนละแท็บ → แต่ละแท็บถือคนละบริษัทได้
 * เวลา window.open หน้าเดียวกัน เบราว์เซอร์จะ "ก๊อป" sessionStorage ของแท็บต้นทาง
 * มาให้แท็บใหม่ (token/id/role จึงติดมาเอง ไม่ต้อง login ซ้ำ) แต่ activeCompanyId
 * ที่ติดมาจะเป็นของบริษัทต้นทาง — ตรงนี้คือจุดที่ต้องเขียนทับ
 *
 * ต้องรันแบบ synchronous ก่อน React render (import ที่บรรทัดแรกของ index.js)
 * ไม่งั้น query ชุดแรกจะยิงออกไปพร้อม company_id ของบริษัทเดิม
 *
 * ไม่ลบ ?company= ออกจาก URL — เผื่อผู้ใช้ refresh หรือ bookmark แท็บนั้นไว้
 */
const HANDOFF_PREFIX = 'companyHandoff:';

/** portal เรียกก่อนเปิดแท็บ — ฝากชื่อ/สีไว้ให้แท็บใหม่หยิบไปใช้ทันที ไม่ต้องรอ API */
export const putCompanyHandoff = (company) => {
  if (!company?.id) return;
  try {
    localStorage.setItem(
      HANDOFF_PREFIX + company.id,
      JSON.stringify({ name: company.companyName || '', color: company.themeColor || '' }),
    );
  } catch (e) {
    // localStorage เต็ม/ถูกปิด — ไม่เป็นไร Navbar เติมชื่อให้ทีหลังได้
  }
};

const readHandoff = (companyId) => {
  try {
    const raw = localStorage.getItem(HANDOFF_PREFIX + companyId);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const applyCompanyFromUrl = () => {
  let companyId = null;
  try {
    companyId = new URLSearchParams(window.location.search).get('company');
  } catch (e) {
    return null;
  }
  if (!companyId || !/^\d+$/.test(companyId)) return null;

  const current = sessionStorage.getItem('activeCompanyId');
  if (String(current) === String(companyId)) return companyId; // แท็บนี้ตั้งไว้แล้ว (เช่นกด refresh)

  sessionStorage.setItem('activeCompanyId', String(companyId));
  sessionStorage.setItem('location', 'workspace');

  const handoff = readHandoff(companyId);
  // ล้างของบริษัทเดิมทิ้งเสมอ ถ้าไม่มีข้อมูลใหม่ — ยอมให้ว่างชั่วคราว
  // ดีกว่าโชว์ชื่อบริษัทผิดค้างไว้จนกว่า API จะตอบ
  if (handoff?.name) sessionStorage.setItem('companyName', handoff.name);
  else sessionStorage.removeItem('companyName');

  if (handoff?.color) sessionStorage.setItem('companyColor', handoff.color);
  else sessionStorage.removeItem('companyColor');

  return companyId;
};

// รันทันทีตอน import
applyCompanyFromUrl();
